import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { getPostBySlug } from '../../utils/blogUtils'
import { formatDate } from '../../utils/dateUtils'
import PageLayout from '../../components/PageLayout'
import './style.css'
import { TravelPost } from './TravelPost'

export const BlogPost = () => {
  const { slug } = useParams()
  const [post, setPost] = useState({
    content: '',
    metadata: {
      title: '',
      date: '',
      description: ''
    }
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const postData = await getPostBySlug(slug);
        
        if (postData) {
          setPost({
            content: postData.content,
            metadata: postData.metadata,
          })
          setError(null)
        } else {
          setError('post-not-found')
          console.error('Post not found')
        }
      } catch (error) {
        console.error('Error loading blog post:', error);
        setError('fetch-error');
      } finally {
        setLoading(false);
      }
    }

    fetchPost();
  }, [slug])

  if (loading) {
    return (
      <PageLayout title="Loading..." className="blog-post">
        <div className="blog-container">
          <div className="loading">Loading...</div>
        </div>
      </PageLayout>
    )
  }
  
  if (error) {
    return (
      <PageLayout title="Post Not Found" className="blog-post">
        <div className="blog-container error-container">
          <Link to="/blog" className="back-link">← Back to Blog</Link>
          <div className="error-content">
            <h1>{error === 'post-not-found' ? 'Post Not Found' : 'Error Loading Post'}</h1>
            <p>
              {error === 'post-not-found'
                ? `Sorry, the blog post "${slug}" could not be found.`
                : 'There was a problem loading this blog post. Please try again later.'}
            </p>
            <Link to="/blog" className="error-button">
              Return to Blog Home
            </Link>
          </div>
        </div>
      </PageLayout>
    )
  }

  if (post.metadata.location) {
    return <TravelPost post={{ ...post.metadata, content: post.content }} />
  }

  return (
    <PageLayout 
      title={post.metadata.title || 'Blog Post'} 
      description={post.metadata.description}
      className="blog-post"
    >
      <div className="blog-container">
        <div className="blog-header">
          <Link to="/blog" className="back-link">← Back to Blog</Link>
          <h1 className="blog-title">{post.metadata.title}</h1>
          {post.metadata.date && <div className="blog-date">{formatDate(post.metadata.date)}</div>}
        </div>
        <div className="blog-content markdown-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {post.content}
          </ReactMarkdown>
        </div>
      </div>
    </PageLayout>
  )
}